var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Introduction")]),_c('InputEditorMultiline',{attrs:{"question":_vm.question,"placeholder":_vm.placeholder},model:{value:(_vm.$tera.project.intro),callback:function ($$v) {_vm.$set(_vm.$tera.project, "intro", $$v)},expression:"$tera.project.intro"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }